import { useSync } from '../context/SyncContext'

export function ThemeToggle() {
  const { settings, toggleTheme } = useSync()
  const isLight = settings.theme === 'light'
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggleTheme}
      aria-pressed={isLight}
      title={isLight ? 'Zu Dark Mode wechseln' : 'Zu White Mode wechseln'}
    >
      <span className="theme-toggle__icon" aria-hidden>
        {isLight ? '☾' : '☀'}
      </span>
      <span className="theme-toggle__label">{isLight ? 'Dark Mode' : 'White Mode'}</span>
    </button>
  )
}
